<template>
    <div class="recap-step2 row">
        <div class="">
            <div class="rdv-extfield-bloc">
                <div class="mb-3">
                    <h3 class="title">Informations complémentaires du rendez-vous</h3>
                    <p class="card-subtitle">Veuillez remplir les champs suivants pour finaliser votre réservation</p>
                </div>
                <div class="rdv-extra-fields-container">
                    <!-- Formulaire des champs extra -->
                    <form @submit.prevent="handleSubmit" class="d-flex" id="rdv_extra_fields_form">
                        <div class="" style="display: grid; grid-template-columns: auto auto;">
                             <div class="field"  v-for="(field, index) in prestations_fields" :key="index"
                            >
                                <label class="label">
                                    {{ field.name }}
                                    <span v-if="field.required" class="required">*</span>
                                </label>
                                
                                <div class="control">
                                    <!-- -- Champ Téléphone -- -->
                                    <input
                                        v-if="field.data_type === 'telephone'"
                                        @input="formatPhone"
                                        class="input is-rounded"
                                        type="tel"
                                        maxlength="14"
                                        :placeholder="field.description || 'Entrez votre numéro'"
                                        :required="!!field.required"
                                        :id="`field-${field.internal_col_name}-${index}`"
                                        :field_name="field.internal_col_name"
                                        v-model="formData[field.internal_col_name]"
                                        @blur="validateAndNotify"
                                    />
                
                                    <!-- <-- Champs standards -- -->
                                    <input
                                        v-else-if="['text', 'email', 'date', 'number'].includes(field.data_type)"
                                        class="input is-rounded"
                                        :type="field.data_type"
                                        :placeholder="field.description || `Entrez ${field.name.toLowerCase()}`"
                                        :required="!!field.required"
                                        :id="`field-${field.internal_col_name}-${index}`"
                                        :field_name="field.internal_col_name"
                                        v-model="formData[field.internal_col_name]"
                                        @blur="validateAndNotify"
                                    />
                
                                    <!-- <-- Textarea -- -->
                                    <textarea
                                        v-else-if="field.data_type === 'textarea'"
                                        class="textarea is-rounded"
                                        :required="!!field.required"
                                        :id="`field-${field.internal_col_name}-${index}`"
                                        :field_name="field.internal_col_name"
                                        :placeholder="field.description || `Entrez ${field.name.toLowerCase()}`"
                                        v-model="formData[field.internal_col_name]"
                                        rows="4"
                                        @blur="validateAndNotify"
                                    ></textarea>
                
                                    <!-- Select  -->
                                    <div v-else-if="field.data_type === 'select'"
                                        class="select is-rounded is-flex-grow-1 is-flex">
                                        <select 
                                            :id="`field-${field.internal_col_name}-${index}`" 
                                            :required="!!field.required" 
                                            class="is-flex-grow-1" 
                                            :field_name="field.internal_col_name"
                                            v-model="formData[field.internal_col_name]"
                                            @change="validateAndNotify"
                                        >
                                            <option value="">-- Sélectionnez --</option>
                                            <option 
                                                v-for="(option, idx) in field.data_values.split(',')" 
                                                :key="idx" :value="option.trim()"
                                            >
                                                {{ option.trim() }}
                                            </option>
                                        </select>
                                    </div>
                
                                    <!-- <-- Checkbox  -->
                                    <div v-else-if="field.data_type === 'checkbox'"
                                             :id="`rdv-field-${field.internal_col_name}`" class="checkbox-group">
                                        <div  v-for="(option, idx) in getCheckboxOptions(field)" 
                                        :key="idx" class="checkbox-item"
                                        >
                                            <label class="checkbox">
                                                <input
                                                    type="checkbox"
                                                    :id="`option-${field.efs_id}-${option.value}-${index}`"
                                                    :value="option.value"
                                                    :field_name="field.internal_col_name"
                                                    v-model="checkboxData[field.internal_col_name]"
                                                    @change="handleCheckboxChange(field.internal_col_name)"
                                                />
                                                <span>{{ option.label }}</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                
                                <!-- <-- Description du champ si existe  -->
                                <small v-if="field.description" class="field-hint">
                                    {{ field.description }}
                                </small>
                
                                <!-- <-- Message d'erreur  -->
                                <div v-if="errors[field.internal_col_name]" class="error-message">
                                    <i class="icon-alert"></i>
                                    {{ errors[field.internal_col_name] }}
                                </div>
                            </div>
                        </div>
                        <!-- Section pièce jointe ajoutée ici -->
                        <AttachmentSection
                            v-if="shouldShowAttachment"
                            :attachment="attachment"
                            :prestation="prestations[0]"
                            :accepted-file-types="acceptedFileTypes"
                            @update:attachment="handleAttachmentUpdate"
                            class="full-width"
                        />
                        <!-- v-model:attachment="attachment" -->
                         <div v-if="attachmentError" class="error-message full-width">
                            <i class="icon-alert"></i>
                            {{ attachmentError }}
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AttachmentSection from '../SharedComponents/AttachmentSection.vue';
export default {
    name: 'RdvExtraFieldsForm',
    components: {
        AttachmentSection
    },
    emits: ['fields-validated', 'form-validity-changed', 'update-attachment'],
    props: {
        rdv_data: { type: Object, required: true },
        prestations: { type: Array, required: true },
        config: { type: Object, required: true },
        group_size: { type: Number, default: 1 },
        fo_config: { type: Object, default: () => ({}) },
        prestations_fields: { type: Array, required: true },
        initialAttachment: { type: [File, Object], default: null }
    },

    data() {
        return {
            formData: {},
            checkboxData: {},
            errors: {},
            is_loading: false,
            attachment: null,
            allowedExtensions: [
            'jpg', 'jpeg', 'png',
            'doc', 'docx',
            'xls', 'xlsx',
            'ppt', 'pptx',
            'odt', 'ods', 'odp',
            'pdf', 'txt', 'csv', 'rtf'
        ],
        maxFileSizeBytes: 2 * 1024 * 1024,  // 2 Mo 
        attachmentError: ''  
        };
    },
    computed: {
        shouldShowAttachment() {
            return this.prestations.length > 0 && this.config['MULTIPLE_RDV'] == 0 &&
                   (this.prestations[0].allow_attachment == 1 || this.prestations[0].force_attachment);
        },
        acceptedFileTypes() {
            return [
                'image/jpeg', 'image/png',
                'application/msword',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/vnd.ms-excel',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'application/vnd.ms-powerpoint',
                'application/vnd.openxmlformats-officedocument.presentationml.presentation',
                'application/vnd.oasis.opendocument.text',
                'application/vnd.oasis.opendocument.spreadsheet',
                'application/vnd.oasis.opendocument.presentation',
                'application/pdf', 'text/plain', 'text/csv', 'application/rtf'
            ].join(',');
        }
    },
    methods: {


        validateAttachmentType() {
             this.attachmentError = '';   

            if (!this.attachment) return true;

            const ext = (this.attachment.name || '').split('.').pop().toLowerCase();
            if (!this.allowedExtensions.includes(ext)) {
                this.attachmentError =
                    'Type de fichier non autorisé. ' +
                    'Formats acceptés : JPG, PNG, DOC, DOCX, XLS, XLSX, PPT, PPTX, ODT, ODS, ODP, PDF, TXT, CSV, RTF.';
                return false;
            }

            if (this.attachment.size > this.maxFileSizeBytes) {
                const sizeMo = (this.attachment.size / (1024 * 1024)).toFixed(2);
                this.attachmentError =
                    `Le fichier est trop volumineux (${sizeMo} Mo). La taille maximale autorisée est de 2 Mo.`;
                return false;
            }

            return true;
        },

        formatDateToFR(date) {
            if (!date) return '';

            if (date.includes('/')) return date;

            const parts = date.split('-');
            if (parts.length !== 3) return date;

            const [year, month, day] = parts;
            return `${day}/${month}/${year}`;
        },
        handleAttachmentUpdate(file) {
            this.attachment = file;
            this.attachmentError = '';  
            this.$emit('update-attachment', file);
        },
        formatPhone(event) {
            let value = event.target.value.replace(/\D/g, '');
            if (value.length > 0) {
                value = value.match(/.{1,2}/g).join(' ');
            }
            event.target.value = value;
        },

        getCheckboxOptions(field) {
            if (field.options) return field.options;
            
            if (field.data_values) {
                return field.data_values.split(',').map(val => ({
                    value: val.trim(),
                    label: val.trim()
                }));
            }
            
            return [];
        },
        initializeFormData() {
            this.prestations_fields.forEach(field => {
                if (field.data_type === 'checkbox') {
                    let initialValue = [];
                    
                    if (this.rdv_data[field.internal_col_name]) {
                        if (Array.isArray(this.rdv_data[field.internal_col_name])) {
                            initialValue = [...this.rdv_data[field.internal_col_name]];
                        } else if (typeof this.rdv_data[field.internal_col_name] === 'string') {
                            // Si c'est une string, la splitter
                            initialValue = this.rdv_data[field.internal_col_name].split(',').map(item => item.trim()).filter(item => item);
                        } else {
                            initialValue = [this.rdv_data[field.internal_col_name]];
                        }
                    }
                    // S'assurer que toutes les valeurs sont des strings
                    initialValue = initialValue.map(item => String(item)).filter(item => item);
                    this.checkboxData[field.internal_col_name] = initialValue;
                    
                    // Pour formData, on stocke en string pour éviter les problèmes de conversion
                    this.formData[field.internal_col_name] = initialValue.length > 0 ? initialValue.join(', ') : '';
                    
                } else {
                    this.formData[field.internal_col_name] = 
                        this.rdv_data[field.internal_col_name] || 
                        field.default_value || '';
                }
            });
            
            // Notifier le parent de l'état initial
            this.$nextTick(() => {
                this.validateAndNotify();
            });
        },
        handleCheckboxChange(fieldName) {
            // S'assurer que toutes les valeurs sont des strings avant de joindre
            const stringValues = this.checkboxData[fieldName].map(item => String(item)).filter(item => item);
            this.formData[fieldName] = stringValues.length > 0 ? stringValues.join(', ') : '';
            this.validateAndNotify();
        },
        validateAndNotify() {
            const isValid = this.validateFields();
            this.$emit('form-validity-changed', isValid);
        },
        goToNextStep() {
            console.log('goToNextStep called');
            return this.handleSubmit();
        },
        // Méthode publique appelée par le parent
        handleSubmit() {
            console.log('handleSubmit called');

            if (!this.validateFields()) {
                console.log('Validation failed');
                return false;
            }
             // Valider la pièce jointe si obligatoire
            if (this.shouldShowAttachment && this.prestations[0].force_attachment && !this.attachment) {
                this.attachmentError = 'Veuillez joindre un fichier obligatoire.'; 
                return false;
            }

            if (!this.validateAttachmentType()) return false; 


            console.log('Validation successful');
            const validatedData = {};
            
            this.prestations_fields.forEach(field => {
                if (field.data_type === 'checkbox') {
                    validatedData[field.internal_col_name] = this.checkboxData[field.internal_col_name]
                        .map(item => String(item))
                        .filter(item => item)
                        .join(', ');
                } else {
                    validatedData[field.internal_col_name] = this.formData[field.internal_col_name];
                }

                if (field.data_type === 'date' && validatedData[field.internal_col_name]) {
                    validatedData[field.internal_col_name] = this.formatDateToFR(
                        validatedData[field.internal_col_name]
                    );
                }
            });

            console.log('Validated data to send:', validatedData);
            this.$emit('fields-validated', validatedData);
            return true;
        },
        validateFields() {
            this.errors = {};

            for (const field of this.prestations_fields) {
                const name = field.internal_col_name;
                const value = field.data_type === 'checkbox' 
                    ? this.checkboxData[name]
                    : this.formData[name];

                // Vérifier les champs obligatoires
                if (field.required) {
                    if (!value || (Array.isArray(value) && value.length === 0) || 
                        (typeof value === 'string' && value.trim() === '')) {
                        this.errors[name] = `Le champ "${field.name}" est obligatoire.`;
                        return false;
                    }
                }

                // Validation spécifique pour les dates
                if (field.data_type === 'date' && value) {
                    const dateRegex = /^(\d{4})-(\d{2})-(\d{2})$/;
                    if (!dateRegex.test(value)) {
                        this.errors[name] = this.getValidationMessage(field);
                        return false;
                    }
                }

                // Validation pour les emails
                if (field.data_type === 'email' && value) {
                    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    if (!emailRegex.test(value)) {
                        this.errors[name] = this.getValidationMessage(field);
                        return false;
                    }
                }

                // Validation pour les téléphones
                if (field.data_type === 'telephone' && value) {
                    const phoneRegex = /^[\d\s]{10,14}$/;
                    if (!phoneRegex.test(value)) {
                        this.errors[name] = this.getValidationMessage(field);
                        return false;
                    }
                }
            }
            return Object.keys(this.errors).length === 0;
        },
        getValidationMessage(field) {
            const messages = {
                email: `Le champ "${field.name}" doit être un email valide.`,
                telephone: `Le champ "${field.name}" doit être un numéro de téléphone valide.`,
                date: `Le champ "${field.name}" doit être une date valide.`
            };
            return messages[field.data_type] || `Le champ "${field.name}" est invalide.`;
        },
    },
    watch: {
        formData: {
            deep: true,
            handler() {
                this.validateAndNotify();
            }
        },
        checkboxData: {
            deep: true,
            handler() {
                this.validateAndNotify();
            }
        },
        initialAttachment: {
            immediate: true,
            handler(newAttachment) {
                if (newAttachment) {
                    this.attachment = newAttachment;
                }
            }
        },
        attachment: {
            handler(newVal) {
                console.log('📎 RdvExtraFieldsForm - Attachment changed:', newVal);
                this.$emit('update-attachment', newVal);
            },
            deep: true
        }
    },
    mounted() {
        console.log('RdvExtFields component');
        window.scrollTo({ top: 0, behavior: 'smooth' }); // scroll
        this.initializeFormData();
        if (this.initialAttachment) {
            this.attachment = this.initialAttachment;
        }
    }
};
</script>

<style scoped>

    .rdv-extra-fields-container {
        max-width: 900px;
        margin: 0 auto;
        box-sizing: border-box;
        width: 100%;
    }
    .title {
        font-weight: 700;
        font-size: 24px;
    }
    #rdv_extra_fields_form {
        width: 100%;
        display: flex;
        flex-direction: column;
    }

    /* Le wrapper qui contient les champs - structure corrigée */
    #rdv_extra_fields_form > div:first-child {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 1rem;
        width: 100%;
        padding: 0;
        margin-bottom: 1.5rem;
    }

    .field {
        width: 100%;
        min-width: 0;
        display: flex;
        flex-direction: column;
    }

    /* Labels */
    .field .label {
        font-weight: 700;
        letter-spacing: 0px;
        display: block;
        font-size: 0.9rem;
        color: #2d3748;
        margin-bottom: 0.5rem;
    }

    .required {
        color: #e53e3e;
        margin-left: 0.25rem;
    }

    /* Control wrapper */
    .field .control {
        width: 100%;
    }

    /* Tous les inputs, textarea, select */
    .field .input,
    .field .textarea,
    .field .select select {
        width: 100%;
        max-width: 100%;
        padding: 0.75rem;
        font-size: 0.9rem;
        border: 2px solid #e2e8f0;
        border-radius: 8px;
        transition: all 0.2s ease;
        box-sizing: border-box;
        background-color: white;
    }

    .field .input:focus,
    .field .textarea:focus,
    .field .select select:focus {
        outline: none;
        border-color: #667eea;
        box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
    }

    /* Textarea */
    .field .textarea {
        min-height: 90px;
        resize: vertical;
        font-family: inherit;
    }

    /* Select wrapper */
    .field .select {
        width: 100%;
        position: relative;
    }

    .field .select.is-flex {
        display: block;
    }

    .field .select select {
        appearance: none;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%232d3748' d='M6 9L1 4h10z'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: right 0.75rem center;
        padding-right: 2.5rem;
        cursor: pointer;
    }

    /* Checkbox container */
    .field .checkbox {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        margin-bottom: 0.5rem;
        font-size: 0.85rem;
        cursor: pointer;
    }

    .field .checkbox input[type="checkbox"] {
        width: auto;
        min-width: auto;
        margin: 0;
        cursor: pointer;
    }

    .field .checkbox span {
        user-select: none;
    }

    /* Field hint */
    .field-hint {
        display: block;
        color: #718096;
        font-size: 0.8rem;
        font-style: italic;
        margin-top: 0.35rem;
    }

    /* Error message - apparaît en dehors de la grille */
    .error-message {
        padding: 0.25rem;
        color: #c53030;
        display: flex;
        align-items: center;
        gap: 0.75rem;
        font-size: 0.9rem;
        margin-top: 0.25rem;
        width: 100%;
        box-sizing: border-box;
    }

    .error-message i {
        font-size: 1.25rem;
        flex-shrink: 0;
    }

    /* Form actions - boutons à la fin */
    .form-actions {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        gap: 1rem;
        padding-top: 1.5rem;
        width: 100%;
        margin-top: auto;
    }

    /* Buttons */
    .enregistrer:disabled {
        cursor: not-allowed;
        background-color: #07070796;
        border: none;
    }

    /* Card subtitle */
    .card-subtitle {
        font-size: 0.95rem;
        font-weight: 500;
        font-family: "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
        color: #718096;
        margin: 0.25rem 0 0.5rem 0;
    }

    /* Responsive */
    @media (max-width: 992px) {
        .title{
            margin-top: 1.5rem !important;
        }
    }
    @media (max-width: 768px) {
        #rdv_extra_fields_form > div:first-child {
            grid-template-columns: 1fr;
        }

        .form-actions {
            flex-direction: column-reverse;
            align-items: stretch;
        }

        .enregistrer {
            width: 100%;
        }
        .title{
            margin-top: 0.5rem !important;
        }
    }

    /* Pour les champs qui doivent occuper toute la largeur (textarea par exemple) */
    .field.full-width {
        grid-column: 1 / -1;
    }
</style>
